/*
 * @Author: Fu Zhuohang
 * @Date: 2022-01-28 09:25:40
 * @LastEditors: Fu Zhuohang
 * @LastEditTime: 2022-02-17 19:06:29
 * @FilePath: \yunshu6.0-3\modules\@cloudpivot\form\src\components\Owner\conduct.ts
 * @Description:
 */
import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import { formatterValueToSetStatus } from "../../../../form/utils";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: "拥有者" }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: "人员单选" }),
        mappings: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/user-selection-map2.vue"),
            options: {},
            formatter: formatterValueToSetStatus,
        },
    },
};
